export function setHtmlFontSize(_window, _document) {
  const fn = () => {
    const html = _document.getElementsByTagName('html')[0];
    const oWidth = _document.documentElement.clientWidth || _document.body.clientWidth;
    html.style.fontSize = `${oWidth / 3.75}px`;
  };
  fn();
  _window.addEventListener('resize', fn);
}
